import { render, staticRenderFns } from "./onboarding-status.vue?vue&type=template&id=dc8e1b98"
import script from "./onboarding-status.vue?vue&type=script&lang=js"
export * from "./onboarding-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports